import type {MatrixCell} from "./football";
export function matrixRowTotals(matrix:MatrixCell[][],index:number,opponents:number[]){
 let goalsFor=0,goalsAgainst=0,points=0;
 for(const opponent of opponents){if(opponent===index)continue;const cell=matrix[index]?.[opponent];if(!cell)continue;
  const scores=cell.results??(cell.score?[{score:cell.score}]:[]);
  for(const result of scores){const score=result.score.match(/^\s*(\d+)\s*[:–−-]\s*(\d+)\s*$/);if(!score)continue;const gf=Number(score[1]),ga=Number(score[2]);goalsFor+=gf;goalsAgainst+=ga;points+=gf>ga?3:gf===ga?1:0;}
 }
 return {goalsFor,goalsAgainst,goalDiff:goalsFor-goalsAgainst,points};
}
